import { Mapper } from './base-mapper';
import type { Method } from '@/types/Method';
import type { GetMethodResponseDTO } from '@/core/dto/method';

export class MethodFindOneMapper implements Mapper<Method> {
	private readonly id: string;
	private readonly name: string;
	private readonly description: string;
	private readonly is_public: boolean;

	constructor({ id, name, description, is_public }: GetMethodResponseDTO) {
		this.id = id;
		this.name = name;
		this.description = description;
		this.is_public = is_public;
	}

	toDomain(): Method {
		return {
			id: this.id,
			name: this.name,
			description: this.description,
			is_public: Boolean(this.is_public)
		};
	}
}
